import React, { useEffect, useState } from "react";
import { useNavigation, useAuth } from "react-uicomp";
import Select from "react-select";

// ACTIONs
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getCollaboratorsAction,
  deleteCollaboratorAction,
  getResearchProgramAction,
} from "../../actions/Actions";

// HOCS
import CompWrapper from "../hocs/CompWrapper.hoc";

// COMMON
import { InvertedButton } from "../common/button/Button.common";
import Table from "../common/table/Table.common";

// HELPER
import { FILE_URL } from "../../config/Config";

const CollaboratorsPage = (props) => {
  const {
    getCollaboratorsAction,
    deleteCollaboratorAction,
    collaborator,
    getResearchProgramAction,
    researchProgram,
  } = props;
  const { listLoader, listCount, list, deleteLoader } = collaborator;
  const { listResearchPorgram } = researchProgram;

  const { location, navigation } = useNavigation();

  const [researchProgramOption, setResearchProgramOption] = useState([]);
  const [selectedResearchProgram, setSelectedResearchProgram] = useState([]);

  const { toast } = useAuth();
  const { navigate, routes } = navigation;
  let query = useQuery();

  function useQuery() {
    return new URLSearchParams(location?.search);
  }
  const pageNumber = query.get("page") || 1;

  useEffect(() => {
    getCollaboratorsAction(pageNumber, selectedResearchProgram?.id);
  }, [getCollaboratorsAction, pageNumber, selectedResearchProgram]);

  const deleteHandler = (id) => {
    deleteCollaboratorAction(id, toast, pageNumber);
  };

  const editHandler = (id) => {
    navigate(`collaborator/edit/${id}`);
  };

  useEffect(() => {
    const remappedResearchProgramList = listResearchPorgram?.map(
      (item, index) => {
        return {
          id: item.id,
          label: item.name.en,
          value: item.name.en,
        };
      },
    );

    const allappendedResearchProgramList = [
      { id: 0, label: "All", value: "" },
      ...remappedResearchProgramList,
    ];
    setResearchProgramOption(allappendedResearchProgramList);
  }, [listResearchPorgram]);

  useEffect(() => {
    getResearchProgramAction(1);
  }, [getResearchProgramAction]);

  const handleResearchProgram = (selectedOptions) => {
    setSelectedResearchProgram(selectedOptions);
    navigate(location.pathname + `?page=` + Number(1));
    getCollaboratorsAction(pageNumber, selectedOptions?.id);
  };

  useEffect(() => {
    const remappedResearchProgramList = listResearchPorgram?.map(
      (item, index) => {
        return {
          id: item.id,
          label: item.name.en,
          value: item.name.en,
        };
      },
    );

    const allappendedResearchProgramList = [
      { id: 0, label: "All", value: "" },
      ...remappedResearchProgramList,
    ];
    setResearchProgramOption(allappendedResearchProgramList);
  }, [listResearchPorgram]);

  return (
    <CompWrapper>
      <div className="newspage-container">
        <div className="newspage">
          <div className="newspage-head">
            <div className="newspage-head-title">Collaborator</div>

            <Select
              isMulti={false}
              options={researchProgramOption}
              value={selectedResearchProgram}
              onChange={handleResearchProgram}
              placeholder="Select Research Program"
            />

            <div className="newspage-head-button">
              <div style={{ width: 100 }}>
                <InvertedButton
                  title="Add"
                  onClick={() => {
                    navigate(routes["Add Collaborator"].path);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="newspage-list">
            <Table
              columns={[
                {
                  field: "image",
                  render: (rowData) => (
                    <img
                      alt="thumbnail"
                      src={FILE_URL + rowData}
                      style={{ height: 100, borderRadius: 4 }}
                    />
                  ),
                },
                {
                  field: "description",
                  name: "name",
                  render: (rowData) => <p>{rowData?.name?.en}</p>,
                },
                {
                  field: "description",
                  name: "नाम",
                  render: (rowData) => <p>{rowData?.name?.np}</p>,
                },
                {
                  field: "description",
                  name: "Website",
                  render: (rowData) => <p>{rowData?.website}</p>,
                },
              ]}
              data={list}
              actions
              dataLoader={listLoader}
              totalCount={listCount}
              deleteLoader={deleteLoader}
              onDeleteHandler={deleteHandler}
              onEditHandler={editHandler}
            />
          </div>
        </div>
      </div>
    </CompWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    collaborator: state.collaborator,
    researchProgram: state.researchProgram,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCollaboratorsAction,
      deleteCollaboratorAction,
      getResearchProgramAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CollaboratorsPage);
